/**
 * Delay (ms) before navigating to a view page after create/update.
 * Absorbs database replication lag so the view does not hit 404.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const POST_SAVE_REDIRECT_DELAY_MS = 500;
